import { apiSlice } from "./apiSlice";
import { ENGLISHQIESBLUEPRINT_URL } from "../constants";

export const englishQuizBlueprintApiSlice =
  apiSlice.injectEndpoints({
    endpoints: (builder) => ({

      // ======================================================
      // CREATE BLUEPRINT
      // POST /api/english-quiz-blueprint/:quizId
      // ======================================================

   createEnglishQuizBlueprint: builder.mutation({
  query: ({ quizId, blueprint }) => {

    const actualUrl =
      `${ENGLISHQIESBLUEPRINT_URL}/english-quiz/${quizId}`;

    console.log(
      "🔥🔥🔥 CREATE ENGLISH BLUEPRINT MUTATION 🔥🔥🔥"
    );

    console.log(
      "ENGLISHQIESBLUEPRINT_URL =",
      ENGLISHQIESBLUEPRINT_URL
    );

    console.log(
      "quizId =",
      quizId
    );

    console.log(
      "ACTUAL REQUEST URL =",
      actualUrl
    );

    console.log(
      "🔥🔥🔥 END MUTATION DEBUG 🔥🔥🔥"
    );

    return {
      url: actualUrl,
      method: "POST",

      body: {
        blueprint,
      },
    };
  },
}),
      // ======================================================
      // GET BLUEPRINT BY QUIZ
      // GET /api/english-quiz-blueprint/quiz/:quizId
      // ======================================================

      getEnglishQuizBlueprintByQuiz: builder.query({
        query: (quizId) => ({
          url: `${ENGLISHQIESBLUEPRINT_URL}/quiz/${quizId}`,
          method: "GET",
        }),

        providesTags: (result, error, quizId) => [
          {
            type: "EnglishQuizBlueprint",
            id: `QUIZ-${quizId}`,
          },
        ],

        keepUnusedDataFor: 5,
      }),

      // ======================================================
      // GET BLUEPRINT BY ID
      // GET /api/english-quiz-blueprint/:id
      // ======================================================

      getEnglishQuizBlueprintById: builder.query({
        query: (blueprintId) => ({
          url: `${ENGLISHQIESBLUEPRINT_URL}/${blueprintId}`,
          method: "GET",
        }),

        providesTags: (result, error, blueprintId) => [
          {
            type: "EnglishQuizBlueprint",
            id: blueprintId,
          },

          ...(result?.quiz?._id
            ? [
                {
                  type: "EnglishQuizBlueprint",
                  id: `QUIZ-${result.quiz._id}`,
                },
              ]
            : []),
        ],

        keepUnusedDataFor: 5,
      }),

      // ======================================================
      // UPDATE BLUEPRINT
      // PUT /api/english-quiz-blueprint/:id
      // ======================================================

      updateEnglishQuizBlueprint: builder.mutation({
        query: ({ blueprintId, ...data }) => {
          console.log(
            "\n========== UPDATE ENGLISH QUIZ BLUEPRINT API =========="
          );

          console.log(
            "Blueprint ID:",
            blueprintId
          );

          console.log(
            "Update data:",
            JSON.stringify(data, null, 2)
          );

          console.log(
            "URL:",
            `${ENGLISHQIESBLUEPRINT_URL}/${blueprintId}`
          );

          console.log(
            "========================================================"
          );

          return {
            url: `${ENGLISHQIESBLUEPRINT_URL}/${blueprintId}`,
            method: "PUT",

            body: data,
          };
        },

        invalidatesTags: (
          result,
          error,
          { blueprintId }
        ) => [
          {
            type: "EnglishQuizBlueprint",
            id: blueprintId,
          },

          "EnglishQuizBlueprint",
          "EnglishQuiz",
        ],
      }),

      // ======================================================
      // DELETE BLUEPRINT
      // DELETE /api/english-quiz-blueprint/:id
      // ======================================================

      deleteEnglishQuizBlueprint: builder.mutation({
        query: (blueprintId) => ({
          url: `${ENGLISHQIESBLUEPRINT_URL}/${blueprintId}`,
          method: "DELETE",
        }),

        invalidatesTags: [
          "EnglishQuizBlueprint",
          "EnglishQuiz",
        ],
      }),

      // ======================================================
      // CHECK BLUEPRINT AVAILABILITY
      //
      // GET
      // /api/english-quiz-blueprint/:id/availability
      //
      // For a question section:
      // available = individual questions
      //
      // For a group section:
      // available = complete groups
      // ======================================================

      getEnglishBlueprintAvailability: builder.query({
        query: (blueprintId) => ({
          url: `${ENGLISHQIESBLUEPRINT_URL}/${blueprintId}/availability`,
          method: "GET",
        }),

        providesTags: (result, error, blueprintId) => [
          {
            type: "EnglishQuizBlueprintAvailability",
            id: blueprintId,
          },
        ],

        keepUnusedDataFor: 5,
      }),

      // ======================================================
      // VALIDATE BLUEPRINT
      //
      // POST
      // /api/english-quiz-blueprint/:id/validate
      // ======================================================

      validateEnglishQuizBlueprint: builder.mutation({
        query: (blueprintId) => ({
          url: `${ENGLISHQIESBLUEPRINT_URL}/${blueprintId}/validate`,
          method: "POST",
        }),

        invalidatesTags: (
          result,
          error,
          blueprintId
        ) => [
          {
            type: "EnglishQuizBlueprintAvailability",
            id: blueprintId,
          },

          {
            type: "EnglishQuizBlueprint",
            id: blueprintId,
          },
        ],
      }),
    }),
  });


// ==========================================================
// Hooks
// ==========================================================

export const {
  // --------------------------------------------------------
  // Blueprint Management
  // --------------------------------------------------------

  useCreateEnglishQuizBlueprintMutation,

  useGetEnglishQuizBlueprintByQuizQuery,

  useGetEnglishQuizBlueprintByIdQuery,

  useUpdateEnglishQuizBlueprintMutation,

  useDeleteEnglishQuizBlueprintMutation,

  // --------------------------------------------------------
  // Availability
  // --------------------------------------------------------

  useGetEnglishBlueprintAvailabilityQuery,

  // --------------------------------------------------------
  // Validation
  // --------------------------------------------------------

  useValidateEnglishQuizBlueprintMutation,

} = englishQuizBlueprintApiSlice;